



































































































































































import Component from 'vue-class-component';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import PartnerDetails from '@/views/dashboard/form101/steps/personal/PartnerDetails.component.vue';
import { Health, PersonalDetails } from '@/models/form/PersonalDetails.model';
import MockData from '@/globals/mock';
import { FORM101_DATA, FORM101_META_DATA, FORM_READ_ONLY_MODE, SET_FORM101_DATA } from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';
import { DOCUMENTS, DOWNLOAD_DOCUMENT, UPLOAD_CLICKED } from '@/types/documents.types';
import { Documents } from '@/models/form/Documents.model';
import { InputFile } from '@/models/InputFile.model';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PartnerDetails,
  },
})
export default class SecondExtraInfoDetails extends FeedbackComponent {

  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public setForm101Data;

  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;


  public mockData: any = MockData.form101;
  public healthOrgs: string[] = [];
  public secondExtraInfoData: PersonalDetails = {} as PersonalDetails;

  public created() {
    this.mockData = MockData.form101;
    this.secondExtraInfoData = this.mockData.personalDetails;
    this.healthOrgs = this.mockData.healthOrg;
    if (!this.form101Data.kibbutzMember) {
      this.updateForm101Data(null, 'incomesToKibbutz');
    }
  }

  @Watch('form101Data.kibbutzMember')
  public kibbutzMemberChanged(newVal: boolean, oldVal: boolean) {
    if (!newVal) {
      this.updateForm101Data(null, 'incomesToKibbutz');
    }
    this.updateForm101Data(newVal, 'kibbutzMember');
  }

  public updateHealthOrg(item: Health | null) {
    if (item !== null) {
      this.setForm101Data({ ...this.form101Data, ['healthOrgName']: item.name });
    }
  }

  public updateForm101Data(newVal: any, property: string) {
    if (!newVal && property === 'healthOrgMember') {
      this.setForm101Data({ ...this.form101Data, ['healthOrgName']: '' });
    }
    this.setForm101Data({ ...this.form101Data, [property]: newVal });
  }


}
